<template>
    <div class="form-container">
        <!-- <div class="columns">
            <div class="column">
                <div id="weight-dimension-instructions">
                    <div class="instructions">
                        <p>{{ $t("Instructions") }}</p>
                        <button
                            class="button c-tog rounded-7 px-15"
                            @click="isOpen = !isOpen"
                            aria-controls="instructions"
                        >
                            {{ isOpen ? $t("Hide") : $t("Show") }}
                        </button>
                    </div>
                    <b-collapse
                        aria-id="instructions"
                        class="panel"
                        animation="slide"
                        :open.sync="isOpen"
                    >
                        <div
                            class="instruction-body"
                            style="padding: 20px; border-raduis: 8px"
                        >
                            {{
                                $t(
                                    "Make sure that all the contents of your shipment are acceptable and not prohibited from importing them to the country to which you want to send this shipment, and also make sure that the amount of content (products) is allowed to be imported for personal use and if it is otherwise, you will need to import these products under a commercial registry with the same activity, and for more information. Please check with the government departments in the country of import responsible for this matter, noting that in the event that you violate this, you will bear the cost of sending the shipment and the cost of returning it to the source country at your own expense, or it may be destroyed without any liability as deemed by the relevant authorities responsible."
                                )
                            }}
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div> -->
        <!-- <div class="columns">
            <div class="column msg" v-show="showMSG">
                <i class="mdi mdi-close" @click="showMSG = false"></i>
                <div>
                    <p>
                        {{
                            $t(
                                "To avoid any holds on your shipment process through the customs or the shipping carrier, you should disclose all shipment’ contents with full discretion."
                            )
                        }}
                    </p>
                    <p>
                        {{
                            $t(
                                "For example; don’t use (clothes) try to be more accurate (Men t-shirt, red color)."
                            )
                        }}
                    </p>
                    <p>
                        {{
                            $t(
                                "If you are student or you have used and personal items try to make it (Personal and used men t-shirt, red color)."
                            )
                        }}
                    </p>
                </div>
            </div>
        </div> -->
        <div class="columns" style="margin-top: 5px">
            <div class="column">
                <p
                    id="form-title-top"
                    :class="{ error: showErrors }"
                    v-if="getViewsForForm2 != 'env'"
                >
                    {{ $t("Describe each unique item.") }}
                </p>
            </div>
        </div>

        <div class="columns">
            <div class="column py-0">
                <!-- <div v-if="!contentItems.length">
                    <div>
                        <p style="width: 100%" class="text">
                            {{ $t("Please choose the currency") }}
                        </p>
                        <div style="width: 100%">
                            <b-field style="width: 200px; margin: 15px 0">
                                <b-select
                                    style="width: 100%; margin: 0"
                                    v-model="current_currency"
                                    :placeholder="$t('Choose the currency')"
                                    expanded
                                >
                                    <option value="USD">
                                        {{ $t("United State Dollar") }}
                                    </option>
                                    <option value="SAR">
                                        {{ $t("Saudi Arabia Riyal") }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div style="margin: 30px 0">
                        <p class="text">
                            {{ $t("Please choose the weight unit") }}
                        </p>
                        <div style="width: 100%">
                            <b-field style="width: 200px; margin: 15px 0">
                                <b-select
                                    style="width: 100%; margin: 0"
                                    v-model="current_unit_System"
                                    :placeholder="$t('Choose the weight unit')"
                                    expanded
                                >
                                    <option value="SU">
                                        {{ $t("lb") }}
                                    </option>
                                    <option value="SI">
                                        {{ $t("KG") }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                </div> -->
                <template v-if="getViewsForForm2 != 'env'">
                    <div>
                        <div v-for="(item, i) in contentItems" :key="i">
                            <!-- <div class="itemParent" style="width: 6%; justify-content: flex-end">
                <div
                  class="addToList"
                  v-if="getViewsForForm2 != 'env'"
                  style="margin-top: 10px"
                >
                  <button
                    v-if="checkInMyList(item)"
                    @click="saveInContentList(item)"
                    class="button"
                    style="
                      width: 85px;
                      font-size: 12px;
                      height: 23px;
                      padding: 0px 30px;
                      margin-bottom: 10px;
                      border: 1px solid #666;
                      transform: rotate(-90deg);
                    "
                  >
                    {{ $t("Add to my list") }}
                  </button>
                </div>
                <div
                  class="delete"
                  style="display: none"
                  @click="deleteItem(item.id)"
                ></div>
              </div> -->
                            <div class="columns">
                                <div class="column is-4">
                                    <p class="secondary-title">
                                        {{ $t("Item") }}
                                    </p>
                                    <b-field>
                                        <b-input
                                            :class="
                                                (!item.title &&
                                                    i + 1 <
                                                        contentItems.length) ||
                                                (!item.title && showErrors)
                                                    ? 'missing-data'
                                                    : ''
                                            "
                                            type="text"
                                            :placeholder="$t('Add item')"
                                            v-model="item.title"
                                        ></b-input>
                                    </b-field>
                                </div>
                                <div class="column is-4">
                                    <p class="secondary-title">
                                        {{
                                            $t(
                                                "The price of the content of the shipment"
                                            )
                                        }}
                                        SAR
                                    </p>
                                    <b-field>
                                        <b-input
                                            :class="
                                                (!item.unit_price &&
                                                    i + 1 <
                                                        contentItems.length) ||
                                                (!item.unit_price && showErrors)
                                                    ? 'missing-data'
                                                    : ''
                                            "
                                            type="number"
                                            :placeholder="$t('Cost')"
                                            v-model="item.unit_price"
                                        ></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <!-- <div class="itemParent is-4">
                 <b-tooltip
                                    :label="
                                        $t('Please use only English letters')
                                    "
                                    :active="notify"
                                    always
                                > 
                  <div class="column">
                    <p class="secondary-title">
                      {{ $t("Item") }}
                    </p>
                    <b-field>
                      <b-input
                        :class="
                          (!item.title && i + 1 < contentItems.length) ||
                          (!item.title && showErrors)
                            ? 'missing-data'
                            : ''
                        "
                        type="text"
                        :placeholder="$t('Add item')"
                        v-model="item.title"
                      ></b-input>
                    </b-field>
                  </div>
                <div class="item">
                  <div class="title tooltip-ex">
                    {{ $t("Item") }}
                  </div>

                  <div class="value">
                    <input
                      :class="
                        (!item.title && i + 1 < contentItems.length) ||
                        (!item.title && showErrors)
                          ? 'missing-data'
                          : ''
                      "
                      type="text"
                      :placeholder="$t('Add item')"
                      v-model="item.title"
                    />
                  </div>

                  <div v-show="showList == i" class="search-results interior">
                    <ul class="interior">
                      <li
                        v-for="(sug_item, index) in searchResult"
                        :key="index"
                        class="interior results"
                        @click="selectSug_item(i, sug_item)"
                      >
                        <div class="interior option">
                          <div class="default-icon">
                            {{ sug_item }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div> 
                </b-tooltip> 
              </div> -->
                            <!-- <div class="itemParent is-4">
                <div class="item price">
                  <div class="title">
                    <span class="tooltip-ex">{{ $t("Cost") }}</span>
                  </div>
                  <div class="value">
                    <input
                      :disabled="getViewsForForm2 == 'env'"
                      :class="
                        (!item.unit_price && i + 1 < contentItems.length) ||
                        (!item.unit_price && showErrors)
                          ? 'missing-data'
                          : ''
                      "
                      type="number"
                      :placeholder="$t('Cost')"
                      v-model="item.unit_price"
                    />
                    <span>
                      {{ item.currency == "USD" ? $t("USD") : $t("SAR") }}
                    </span>
                  </div>
                </div>
              </div> -->

                            <!-- <div class="itemParent">
                <div class="item">
                  <div class="title">
                    {{ $t("item Qyt") }}
                  </div>
                  <div class="value">
                    <input
                      :disabled="getViewsForForm2 == 'env'"
                      :class="
                        (!item.quantity && i + 1 < contentItems.length) ||
                        (!item.quantity && showErrors)
                          ? 'missing-data'
                          : ''
                      "
                      type="number"
                      :placeholder="$t('Quantity')"
                      v-model="item.quantity"
                    />
                  </div>
                </div>
              </div> -->

                            <!-- <div class="itemParent">
                <div class="item price">
                  <div class="title">
                    <span class="tooltip-ex">{{ $t("Weight") }}</span>
                  </div>
                  <div class="value">
                    <input
                      :disabled="getViewsForForm2 == 'env'"
                      :class="
                        (!item.weight && i + 1 < contentItems.length) ||
                        (!item.weight && showErrors)
                          ? 'missing-data'
                          : ''
                      "
                      type="number"
                      :placeholder="$t('Weight')"
                      v-model="item.weight"
                    />
                    <span>
                      {{ item.unit_system == "SU" ? $t("lb") : $t("KG") }}
                    </span>
                  </div>
                </div>
              </div> -->

                            <!-- <div class="itemParent lastParent" style="width: 26%; margin: 0 15px">
                <div class="item">
                  <div class="value" style="display: flex; align-items: center">
                    <p class="title" style="border: none">
                      {{ $t("total") }}
                      {{ $i18n.locale == "en" ? item.title : "" }}
                      {{ $t("Weight") }}
                    </p>
                    <p style="padding: 0 10px; font-weight: bold; color: #686868">
                      {{ (item.weight * item.quantity).toFixed(1) }}
                      {{ item.unit_system == "SI" ? $t("KG") : $t("lb") }}
                    </p>
                  </div>
                  <div class="value" style="display: flex; align-items: center">
                    <p class="title" style="border: none">
                      {{ $t("total") }}
                      {{ $i18n.locale == "en" ? item.title : "" }}
                      {{ $t("Value") }}
                    </p>
                    <p
                      style="
                        padding: 0 10px;
                        font-weight: bold;
                        color: #686868;
                        display: flex;
                        align-items: center;
                      "
                    >
                      {{ (item.quantity * item.unit_price) | currency("") }}

                      {{ $t(item.currency) }}
                    </p>
                  </div>
                </div>

                <div class="delete" @click="deleteItem(item.id)">X</div>
              </div> -->
                        </div>
                    </div>
                    <!-- <div style="display: flex; justify-content: space-between; width: 94%">
            <div v-if="getViewsForForm2 != 'env'" style="width: 100%; display: flex">
              <button
                v-if="!showChoicesList && current_currency && current_unit_System"
                class="button"
                @click="addNewItem"
                id="toggler"
              >
                {{ $t("Add New Item") }}
              </button>

              <button
                v-if="current_currency && current_unit_System"
                style="margin: 0 10px"
                class="button is-outlined add-shipment-type"
                @click="showChoicesList = !showChoicesList"
              >
                {{ $t("My list") }}
              </button>
              <div v-if="showChoicesList" style="width: 350px; padding: 0 25px">
                <b-field>
                  <b-select
                    @input="addContent"
                    v-model="list_content_item"
                    :placeholder="$t('List of choices')"
                    expanded
                  >
                    <option
                      v-for="(item, i) in filteredContentList"
                      :key="i"
                      :value="item"
                    >
                      {{ item.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>

            <div style="text-align: center" v-if="contentItems.length">
              <p>{{ $t("Your total shipment value is") }}</p>
              <p style="font-weight: bold; color: #686868; font-size: 1.2em">
                {{ totalPrice | currency("") }}
                {{ $t(contentItems[0].currency) }}
              </p>
            </div>
          </div> -->
                </template>
                <!-- <template v-else>
                    <div class="column position-relative is-5">
                        <p id="form-title-top">
                            {{
                                $t(
                                    "Describe your document (Transcirpt, Passport, Contract, ...etc)"
                                )
                            }}
                        </p>
                        <b-field>
                            <input
                                @input="typingItem($event, 0)"
                                v-model="contentItems[0].title"
                                class="envTitle"
                            />
                        </b-field>

                        <div
                            v-show="showList == 0"
                            class="search-results interior"
                            style="right: 0"
                        >
                            <ul class="interior">
                                <li
                                    v-for="(sug_item, index) in searchResult"
                                    :key="index"
                                    class="interior results"
                                    @click="selectSug_item(0, sug_item)"
                                >
                                    <div class="interior option">
                                        <div class="default-icon">
                                            {{ sug_item }}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <p
                            v-show="documentDescription == null && showErrors"
                            class="danger"
                        >
                            {{ $t("Required") }}
                        </p>
                    </div>
                </template> -->
                <!-- <div
          style="
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
          "
          v-if="contentItems.length"
        >
          <div style="width: 500px">
            <div class="itemParent">
              <div
                :class="'columns' + !shipmentReson && showErrors ? 'missing-data' : ''"
                style="margin-top: 25px"
                v-if="!domestic_rate"
              >
                <div>
                  <p class="secondary-title">
                    {{ $t("What is the purpose of your Shipment ?") }}
                  </p>

                  <b-field>
                    <b-select
                      v-model="shipmentReson"
                      :placeholder="$t('Please choose one')"
                      expanded
                    >
                      <option value="Gift">
                        {{ $t("Gift") }}
                      </option>
                      <option value="Personal Use">
                        {{ $t("Personal Use") }}
                      </option>
                      <option value="Commercial">
                        {{ $t("Commercial") }}
                      </option>
                      <option value="Return for repair">
                        {{ $t("Return for repair") }}
                      </option>
                      <option value="Return after repair">
                        {{ $t("Return after repair") }}
                      </option>
                    </b-select>
                  </b-field>
                  <p v-show="shipmentReson == null && showErrors" class="danger">
                    {{ $t("Please choose one") }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="column msg"
              v-show="
                !domestic_rate &&
                shipment.sendTo.country == 'Saudi Arabia' &&
                showNote &&
                shipmentReson == 'Personal Use'
              "
            >
              <i class="mdi mdi-close" @click="showNote = false"></i>
              <div>
                <p>
                  {{
                    $t(
                      "To help speed up the shipping process, Enter the recipient Saudi National ID"
                    )
                  }}
                </p>
              </div>
            </div>
            <div
              class="column msg"
              v-show="
                !domestic_rate &&
                shipment.sendTo.country == 'Saudi Arabia' &&
                showNote &&
                shipmentReson == 'Commercial'
              "
            >
              <i class="mdi mdi-close" @click="showNote = false"></i>
              <div>
                <p>
                  {{
                    $t(
                      "To help speed up the shipping process, enter the Registration number for the consignee company"
                    )
                  }}
                </p>
              </div>
            </div>

            <div
              class="columns"
              style="margin-top: 25px"
              v-if="
                !domestic_rate &&
                shipment.sendTo.country == 'Saudi Arabia' &&
                shipmentReson == 'Personal Use'
              "
            >
              <div class="column">
                <p class="secondary-title">
                  {{ $t("Add the ID number") }}
                </p>
                <b-field>
                  <b-input v-model="user_identity" class="reference"></b-input>
                </b-field>
              </div>
            </div>
            <div
              class="columns"
              style="margin-top: 25px"
              v-if="
                !domestic_rate &&
                shipment.sendTo.country == 'Saudi Arabia' &&
                shipmentReson == 'Commercial'
              "
            >
              <div class="column">
                <p class="secondary-title">
                  {{ $t("Add the Registration number for the consignee company") }}
                </p>
                <b-field>
                  <b-input v-model="user_identity" class="reference"></b-input>
                </b-field>
              </div>
            </div>

            <div class="columns" style="margin-top: 25px">
              <div class="column">
                <p class="secondary-title">
                  {{ $t("Add a reference number if you would like") }}
                </p>
                <b-field>
                  <b-input v-model="customer_reference" class="reference"></b-input>
                </b-field>
              </div>
            </div>
          </div>
          <div
            v-if="!domestic_rate && shipment.sendTo.country == 'Saudi Arabia'"
            style="width: 450px; display: flex; align-items: flex-end; margin-top: 50px"
          >
            <div style="display: flex; justify-content: flex-end; width: 100%">
              <div id="weight-dimension-instructions" class="note">
                <p class="title" style="margin: 10px 0">
                  {{ $t("Note") }}
                </p>
                <div class="instruction-body" style="margin: 10px 0">
                  <p style="font-size: 14px; text-align: center">
                    {{ $t("You may pay the following charges") }}
                  </p>
                </div>
                <div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      font-size: 13px;
                      padding: 3px 38px;
                    "
                  >
                    <p>
                      {{ $t("Estimated SAUDI Custom Fee") }}
                    </p>
                    <p class="note_price">
                      <span style="padding: 0 5px">
                        {{ sauidiFees | currency("") }}
                      </span>
                      <span style="font-weight: bold">
                        {{ $t("SAR") }}
                      </span>
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      font-size: 13px;
                      padding: 3px 38px;
                    "
                  >
                    <p>{{ $t("Estimated VAT Fee") }}</p>
                    <p class="note_price">
                      <span style="padding: 0 5px">
                        {{ VATFees | currency("") }}
                      </span>
                      <span style="font-weight: bold">
                        {{ $t("SAR") }}
                      </span>
                    </p>
                  </div>
                  
                                <div style="
                                            text-align: center;
                                            font-size: 13px;
                                            padding: 25px 38px;
                                        ">
                                    <p>
                                        {{
                                                $t(
                                                    "How to avoid these charges?"
                                                )
                                            }}
                                    </p>
                                </div>
                                
                </div>
              </div>
            </div>
          </div>
        </div> -->
            </div>
        </div>

        <!-- <div
            class="info"
            v-if="
                shipment.sendTo.country == 'Saudi Arabia' ||
                shipment.sendFrom.country == 'Saudi Arabia'
            "
        >
            <div class="info-title">
                <h2>
                    {{ $t("Things to know in the event of a personal import") }}
                </h2>
            </div>

            <div class="top-lists">
                <ul>
                    <b-collapse
                        :open="false"
                        @open="openList.push(1)"
                        @close="filterList(1)"
                        aria-id="p-g"
                    >
                        <li slot="trigger" aria-controls="p-g">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(1) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{
                                $t(
                                    "When is personal goods exempt from customs duties when purchasing from electronic stores from abroad?"
                                )
                            }}
                        </li>
                        <div class="notification">
                            <div>
                                <ul>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        -
                                        {{
                                            $t(
                                                "The total value of purchases is less than 1000 riyals (the total value is calculated so that it includes the value of the goods, freight and insurance)."
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        -
                                        {{
                                            $t(
                                                "There is no requirement for clearance permission from any other party."
                                            )
                                        }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </b-collapse>
                    <b-collapse
                        :open="false"
                        @open="openList.push(2)"
                        @close="filterList(2)"
                        aria-id="p-g"
                    >
                        <li slot="trigger" aria-controls="p-g">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(2) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{ $t("Are personal goods exempt from VAT?") }}
                        </li>
                        <div class="notification">
                            <div>
                                <ul>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        -
                                        {{
                                            $t(
                                                "Personal goods are not exempt from value-added tax except under the value-added tax system that specifies tax exemptions, and value-added tax is applied to all amounts calculated in the customs declaration, including customs duties, meaning that the tax is calculated on the value of the goods, freight, insurance, and customs fees. And customs declaration fees."
                                            )
                                        }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </b-collapse>
                    <b-collapse
                        :open="false"
                        @open="openList.push(3)"
                        @close="filterList(3)"
                        aria-id="q-c"
                    >
                        <li slot="trigger" aria-controls="q-c">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(3) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{
                                $t(
                                    "Quantities controls for personal import of electrotechnical products"
                                )
                            }}
                        </li>
                        <div class="notification" style="margin-top: 15px">
                            <div class="content">
                                <h4 style="color: #000; margin-bottom: 20px">
                                    <span class="blue-label">{{
                                        $t("Two pieces")
                                    }}</span>
                                    <span>
                                        {{
                                            $t(
                                                "as a maximum from these products"
                                            )
                                        }}
                                    </span>
                                </h4>
                                <div
                                    class="pieces"
                                    style="
                                        display: flex;
                                        flex-wrap: wrap;
                                        white-space: nowrap;
                                        align-items: center;
                                    "
                                >
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/charger.svg"
                                        />
                                        <p>{{ $t("Laptop charger") }}</p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/lighting.svg"
                                        />
                                        <p>
                                            {{ $t("Mobile phone batteries") }}
                                        </p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/headset.svg"
                                        />
                                        <p>{{ $t("Wireless headphones") }}</p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/bracelet.svg"
                                        />
                                        <p>{{ $t("Smart bracelet") }}</p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/watch.svg"
                                        />
                                        <p>{{ $t("Smart watches") }}</p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/plug.svg"
                                        />
                                        <p>
                                            {{
                                                $t(
                                                    "Wireless charger for mobile phones"
                                                )
                                            }}
                                        </p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/powerbank.svg"
                                        />
                                        <p>{{ $t("mobile charger") }}</p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/smartphone1.svg"
                                        />
                                        <p>{{ $t("Mobile phone") }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="notification">
                            <div class="content">
                                <h4 style="color: #000; margin-bottom: 20px">
                                    <span class="blue-label">{{
                                        $t("One pieces")
                                    }}</span>
                                    <span>
                                        {{
                                            $t(
                                                "as a maximum from these products"
                                            )
                                        }}
                                    </span>
                                </h4>
                                <div
                                    class="pieces"
                                    style="display: flex; align-items: center"
                                >
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/television.svg"
                                        />
                                        <p>
                                            {{ $t("Televisions and displays") }}
                                        </p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/dishwasher.svg"
                                        />
                                        <p>{{ $t("dish washer") }}</p>
                                    </div>
                                    <div
                                        style="text-align: center; margin: 20px"
                                    >
                                        <img
                                            style="width: 45px"
                                            src="@/assets/images/pump.svg"
                                        />
                                        <p>{{ $t("Electric water pumps") }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                    <b-collapse
                        :open="false"
                        @open="openList.push(4)"
                        @close="filterList(4)"
                        aria-id="cam-c"
                    >
                        <li slot="trigger" aria-controls="cam-c">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(4) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{ $t("Surveillance cameras import Controls") }}
                        </li>
                        <div class="notification">
                            <div>
                                <ul>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        -
                                        {{
                                            $t(
                                                "The import is for a personal purpose"
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        -
                                        {{
                                            $t(
                                                "To be mentioned in the names of people"
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        -
                                        {{
                                            $t(
                                                "It should not be contained in commercial quantities"
                                            )
                                        }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </b-collapse>
                    <b-collapse
                        :open="false"
                        @open="openList.push(5)"
                        @close="filterList(5)"
                        aria-id="Tobacco-c"
                    >
                        <li slot="trigger" aria-controls="Tobacco-c">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(5) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{ $t("Tobacco product import controls") }}
                        </li>
                        <div class="notification">
                            <div>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{ $t("The permitted quantities are:") }}
                                </li>
                                <ul style="padding: 5px 20px">
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{
                                            $t(
                                                "2,400 cigarettes, equivalent to (12) cherries"
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{ $t("125 cigars.") }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{
                                            $t(
                                                "2 kg of molasses or the equivalent of other tobacco products."
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{
                                            $t(
                                                "All tobacco products and derivatives are subject to customs duties of 100% in addition to 100% excise tax in addition to value-added tax of 15%."
                                            )
                                        }}
                                    </li>
                                </ul>

                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                        margin-top: 20px;
                                    "
                                >
                                    -
                                    {{
                                        $t(
                                            "The categories to which these controls, rules and procedures do not apply are:"
                                        )
                                    }}
                                </li>
                                <ul style="padding: 5px 20px">
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{
                                            $t(
                                                "Individuals under the age of 18."
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{
                                            $t(
                                                "Held through the different customs ports."
                                            )
                                        }}
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        {{
                                            $t(
                                                "Seized products that their owners try to bring into the Kingdom through illegal means."
                                            )
                                        }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </b-collapse>
                    <b-collapse
                        :open="false"
                        @open="openList.push(6)"
                        @close="filterList(6)"
                        aria-id="item-c"
                    >
                        <li slot="trigger" aria-controls="item-c">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(6) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{ $t("Prohibited items") }}
                        </li>
                        <div class="notification">
                            <div>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{
                                        $t(
                                            "Pills, intoxicants, and drugs of all kinds"
                                        )
                                    }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{
                                        $t(
                                            "Disks and storage media that contain indecent material"
                                        )
                                    }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Counterfeit coins") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("fireworks") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Forbidden chewing smoke") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Weapons and ammunition") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{
                                        $t(
                                            "Contains a secret photography camera"
                                        )
                                    }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("All kinds of lasers") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Taser") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Speed radar detectors") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("The fruits of the guru") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{
                                        $t(
                                            "Hookah and electronic cigarettes and accessories"
                                        )
                                    }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{ $t("Organs, tools and sexual devices") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    -
                                    {{
                                        $t(
                                            "Eavesdropping devices of all shapes and types"
                                        )
                                    }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Fruit of nutmeg and its powder") }}
                                </li>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    - {{ $t("Teardrops") }}
                                </li>
                            </div>
                        </div>
                    </b-collapse>
                    <b-collapse
                        :open="false"
                        @open="openList.push(7)"
                        @close="filterList(7)"
                        aria-id="sc-s"
                    >
                        <li slot="trigger" aria-controls="sc-s">
                            <span style="font-size: 26px">
                                <img
                                    :class="[
                                        'right-arrow',
                                        { active: openList.includes(7) },
                                    ]"
                                    src="@/assets/images/arrow-more.svg"
                                    style="width: 12px; height: 12px"
                                    alt=""
                                />
                            </span>
                            {{
                                $t("Customs exemption for scholarship students")
                            }}
                        </li>
                        <div class="notification">
                            <div>
                                <li
                                    style="
                                        color: #4a4a4a !important;
                                        font-weight: 100 !important;
                                        font-size: 16px;
                                    "
                                >
                                    <span>
                                        -
                                        {{
                                            $t(
                                                "The scholarship student - whether he is a student or an employee - is exempt from customs duties imposed on used personal items and luggage that he brings from outside the country after the expiration of his scholarship period, and cars are excluded from this exemption."
                                            )
                                        }}
                                    </span>
                                    <span>
                                        {{
                                            $t(
                                                "In order to obtain the aforementioned exemptions, the sponsored person is obliged to provide proof of his scholarship for work or study upon import."
                                            )
                                        }}
                                    </span>
                                </li>
                            </div>
                        </div>
                    </b-collapse>
                </ul>
            </div>

            <div class="info-title-bottom">
                <div>
                    <h2 class="info-title">
                        {{
                            $t(
                                "Things to know in the event of a Commercial import"
                            )
                        }}
                    </h2>
                </div>
                <div class="top-lists">
                    <ul>
                        <b-collapse
                            :open="false"
                            @open="openList.push(8)"
                            @close="filterList(8)"
                            aria-id="Tobacco-c"
                        >
                            <li slot="trigger" aria-controls="Tobacco-c">
                                <span style="font-size: 26px">
                                    <img
                                        :class="[
                                            'right-arrow',
                                            { active: openList.includes(8) },
                                        ]"
                                        src="@/assets/images/arrow-more.svg"
                                        style="width: 12px; height: 12px"
                                        alt=""
                                    />
                                </span>
                                {{
                                    $t(
                                        "Importers are obligated to submit the following documents to start the import process"
                                    )
                                }}
                            </li>
                            <div class="notification">
                                <div>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        <span>
                                            -
                                            {{
                                                $t(
                                                    "A commercial registry carrying the same activity as the imported products."
                                                )
                                            }}
                                        </span>
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        <span>
                                            - {{ $t("Commercial invoice.") }}
                                        </span>
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        <span>
                                            - {{ $t("Shipping Policy.") }}
                                        </span>
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        <span>
                                            -
                                            {{
                                                $t(
                                                    "Certificate of origin (not mandatory if there is a fixed indication of origin)."
                                                )
                                            }}
                                        </span>
                                    </li>
                                </div>
                            </div>
                        </b-collapse>
                        <b-collapse
                            :open="false"
                            @open="openList.push(9)"
                            @close="filterList(9)"
                            aria-id="Tobacco-c"
                        >
                            <li slot="trigger" aria-controls="Tobacco-c">
                                <span style="font-size: 26px">
                                    <img
                                        :class="[
                                            'right-arrow',
                                            { active: openList.includes(9) },
                                        ]"
                                        src="@/assets/images/arrow-more.svg"
                                        style="width: 12px; height: 12px"
                                        alt=""
                                    />
                                </span>
                                {{
                                    $t(
                                        "The importer is also obligated to provide all necessary according to the nature of the imports, including, for example"
                                    )
                                }}
                            </li>
                            <div class="notification">
                                <div>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        <span>
                                            -
                                            {{
                                                $t(
                                                    "Issuing an IECEE certificate for commodities to which the certificate requirement applies."
                                                )
                                            }}
                                        </span>
                                    </li>
                                    <li
                                        style="
                                            color: #4a4a4a !important;
                                            font-weight: 100 !important;
                                            font-size: 16px;
                                        "
                                    >
                                        <span>
                                            -
                                            {{
                                                $t(
                                                    "Registration of products in the competent authorities if these goods require registration."
                                                )
                                            }}
                                        </span>
                                    </li>
                                </div>
                            </div>
                        </b-collapse>
                    </ul>
                </div>
            </div>

            <div
                style="
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    margin-top: 50px;
                "
            >
                <p style="font-size: 14px">
                    {{ $t("These details are fixed by") }}
                </p>
                <img
                    class="logo-sa"
                    style="width: 200px; margin: 0 15px"
                    src="@/assets/images/sa-form4.png"
                />
            </div>
        </div>

        <div class="note">
            <div class="note-body">
                <h4 style="display: flex; align-items: center">
                    <img
                        style="width: 35px; height: 35px"
                        src="@/assets/images/bell.png"
                    />
                    <span>
                        {{ $t("Note") }}
                    </span>
                </h4>
                <div>
                    <p>
                        {{
                            $t(
                                "In case of not following the instructions may effect on the shipping process, and some additional charges and fees may apply, or your shipment will returned to shipper with charging shipping fees."
                            )
                        }}
                    </p>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { globalEvent } from "@/main";

export default {
    data() {
        return {
            showNote: true,
            openList: [],
            current_currency: "SAR",
            current_unit_System: "SI",
            showMSG: true,
            showChoicesList: false,
            list_content_item: null,
            isOpen: true,
            defaultOpenedDetails: [],
            searchResult: [],
            envSuggestions: [
                "Activated Credit/Cash Cards",
                "Airline tickets - issued/validated",
                "Annual reports",
                "Bill of lading",
                "Blueprints",
                "Booklets, brochures - non-advertising",
                "Business cards",
                "Cash letters",
                "Catalogs",
                "Certificates",
                "Charts, graphs",
                "Checkes - cashier",
                "Checks - canceled",
                "COMPLETED FORMS",
                "Contract",
                "Credit note",
                "Deeds",
                "Diaries",
                "Diplomatic Material",
                "Diskettes",
                "Documents - general business",
                "Educational material - printed",
                "Examination papers",
                "Identity document",
                "Invoices - not blank",
                "Letter, correspondence",
                "Manuals - technical",
                "Manuscripts",
                "Media storage device",
                "MEDICAL EXAMINATION RESULT",
                "Microfiche, microfilm",
                "Money orders",
                "Passports",
                "Photographs",
                "Photographs - as part of business reports",
                "Plans, drawings - for architectural, industrial, engineering purposes",
                "Price lists",
                "Printed matter",
                "Ship manifest - computer generated",
                "Shipping schedules",
                "Slides",
                "Transparencies",
                "Visa applications",
            ],
            suggestions: [
                "Clothes",
                "Used Clothes",
                "Books",
                "T-Shirt",
                "Coffee",
                "Dates",
                "batteries",
                "Toys",
                "Perfume",
                "Phone",
                "iPhone",
                "Laptop",
                "iMac",
                "Make Up",
            ],
            sauidiFees: 0,
            VATFees: 0,
            showList: null,
            notify: false,
            shipmentReson: null,
            customer_reference: null,
            contentItems: [],
            totalPrice: null,
            totalContentsWeight: null,
            contentIsFilled: false,
            showErrors: false,
            user_identity: null,
            filteredContentList: [],
        };
    },
    watch: {
        content_list(val) {
            this.filterContentList();
        },
        current_currency(val) {
            this.filterContentList();
        },
        current_unit_System(val) {
            this.filterContentList();
        },
        shipmentReson(val) {
            if ((val != null) & this.contentIsFilled) {
                this.checkFees(this.totalPrice);
                this.$emit("finish", true);
                return true;
            }
            this.$emit("finish", false);
            return false;
        },
        contentItems: {
            immediate: true,
            deep: true,
            handler(val) {
                let error = 0;
                if (this.getViewsForForm2 != "env") {
                    this.totalPrice = val.reduce((total, curr) => {
                        return total + curr.unit_price * curr.quantity;
                    }, 0);
                    this.totalContentsWeight = val.reduce((total, curr) => {
                        return total + curr.weight * curr.quantity;
                    }, 0);
                    val.map((p) => {
                        Object.keys(p).map((key) => {
                            if (key != "id" && key != "hs_code_id") {
                                if (
                                    p[key] == 0 ||
                                    p[key] == "" ||
                                    p[key] == null
                                ) {
                                    error++;
                                }
                            }
                        });
                    });
                } else {
                    if (!val[0].title) error++;
                }
                if (error == 0) {
                    this.contentIsFilled = true;
                    this.$emit("finish", true);
                } else {
                    this.contentIsFilled = false;
                    this.$emit("finish", false);
                    return false;
                }
            },
        },
        totalContentsWeight: {
            immediate: true,
            handler(val) {
                let totalWeight = this.totalWeight;
                if (this.current_unit_System != "SI") {
                    totalWeight = this.totalWeight * 2.20462;
                }
                if (val > totalWeight) {
                    globalEvent.$emit("message", {
                        type: "error",
                        message: `${this.$t(
                            "the contents weight is over than total weight"
                        )} ${this.totalWeight} ${this.$t("KG")}`,
                    });
                    window.scrollTo(0, 0);
                } else {
                    globalEvent.$emit("message", {
                        type: "success",
                        message: this.$t(`available total weight`),
                    });
                }
            },
        },
        totalPrice: {
            immediate: true,
            handler(val) {
                if (this.service && val) {
                    this.checkFees(val);
                }
            },
        },
    },
    methods: {
        filterContentList() {
            if (
                !this.content_list.length ||
                !this.current_currency ||
                !this.current_unit_System
            )
                return [];
            this.filteredContentList = this.content_list.filter(
                (li) =>
                    li.title.includes(this.current_currency) &&
                    li.title.includes(
                        this.current_unit_System == "SI" ? "KG" : "lb"
                    )
            );
        },
        filterList(num) {
            this.openList = this.openList.filter((i) => i !== num);
        },
        addContent() {
            this.showErrors = false;
            this.contentItems.push({
                id: Math.random().toString(16).slice(2),
                title: this.list_content_item.content_title,
                unit_price: this.list_content_item.unit_price,
                quantity: this.list_content_item.quantity,
                weight: this.list_content_item.weight,
                unit_system: this.current_unit_System,
                currency: this.current_currency,
                hs_code_id: null,
            });
            this.showChoicesList = false;
            this.list_content_item = null;
        },
        saveInContentList(item) {
            this.$store
                .dispatch("SAVE_IN_Content_LIST", {
                    item,
                    unit_price: this.current_currency,
                    unit_system: this.current_unit_System,
                })
                .then((res) => {
                    this.$buefy.toast.open({
                        message: this.$t("Added to your list"),
                        type: "is-primary",
                    });
                });
        },
        checkInMyList(item) {
            let title = `${item.title} - ${item.unit_price}${item.currency} - ${
                item.quantity
            } - ${item.weight}${item.unit_system == "SI" ? "KG" : "lb"}`;

            let check = this.content_list.filter((p) => p.title == title);
            if (check.length) return false;
            return true;
        },
        showAllError() {
            this.showErrors = false;
            if (!this.contentItems.length) {
                this.showErrors = true;
                this.$buefy.toast.open({
                    message: this.$t("Describe each unique item."),
                    type: "is-primary",
                });
                window.scrollTo(100, 500);
                return;
            }
            let items = null;
            this.showErrors = true;
            items = document.getElementsByClassName("missing-data");
            items[0].closest(".itemParent").scrollIntoView({
                behavior: "smooth",
            });
            window.scrollTo(100, 500);
        },
        checkFees(val) {
            let avg = 1000;
            if (this.shipmentReson == "Gift") {
                avg = 3000;
            }

            if (this.current_currency == "USD") {
                val = val * 3.75;
            }
            if (Number(val) < Number(avg)) {
                this.VATFees =
                    (Number(val) + Number(this.service.price)) * 0.15;

                this.sauidiFees = 0;
                return;
            }
            this.sauidiFees = (Number(val) + Number(this.service.price)) * 0.05;
            this.VATFees = (Number(val) + Number(this.service.price)) * 0.15;
        },
        selectSug_item(i, sug_item) {
            this.contentItems[i].title = sug_item;
            this.searchResult = [];
            this.showList = null;
        },
        filterSugestion(value) {
            let query = new RegExp(value, "i");
            let searchArr;
            if (this.getViewsForForm2 == "env") {
                searchArr = this.envSuggestions;
            } else {
                searchArr = this.suggestions;
            }
            this.searchResult = searchArr
                .filter((item) => {
                    return query.test(item);
                })
                .slice(0, 4);
        },
        typingItem(e, i) {
            let englishRegex = /[^A-Za-z0-9\s]/gi;
            if (englishRegex.test(e.target.value)) {
                this.contentItems[i].title = null;
                this.notify = true;
                return;
            }
            this.notify = false;

            if (e.target.value) {
                this.suggestions.includes(e.ta);
                this.showList = i;
                this.filterSugestion(e.target.value);
            } else {
                this.showList = null;
            }
        },
        addNewItem() {
            this.showErrors = false;
            this.contentItems.push({
                id: Math.random().toString(16).slice(2),
                title: null,
                unit_price: null,
                quantity: 1,
                weight: 1,
                hs_code_id: null,
                unit_system: this.current_unit_System,
                currency: this.current_currency,
            });
        },
        hideForm() {
            this.$el.classList.add("hide-form-container");
        },
        // shipmentProtection(n) {
        //     this.$store.dispatch("insured", n);
        // },
        deleteItem(id) {
            this.contentItems = this.contentItems.filter(
                (item) => item.id != id
            );
        },
        allowNext() {
            if (this.contentItems.length > 0) {
                return true;
            } else {
                globalEvent.$emit("message", {
                    type: "error",
                    message: this.$t("You need to provide item details."),
                });
                return false;
            }
        },
    },
    computed: {
        getViewsForForm2() {
            return this.$store.getters.getViewsForForm2;
        },
        content_list() {
            return this.$store.getters.content_list;
        },
        domestic_rate() {
            return this.$store.getters.getDomesticRate;
        },
        totalWeight() {
            return this.$store.getters.totalWeight;
        },
        service() {
            return this.$store.getters.getService;
        },
        shipment() {
            return this.$store.getters.shipment;
        },
        insured() {
            if (this.$store.state.shipment.insured == 1) {
                return true;
            } else {
                return false;
            }
        },
        insurance() {
            return this.$store.state.extra_charges.usd.insurance * 3.75;
        },
        from() {
            return this.$store.getters.shipment.sendFrom;
        },
    },
    beforeDestroy() {
        this.$store.dispatch("contents", this.contentItems);
        this.$store.dispatch("REASON", this.shipmentReson);
        this.$store.dispatch("USER_IDENTITY", this.user_identity);
        this.$store.dispatch("CUSTOMER_REFERENCE", this.customer_reference);
        this.$store.dispatch("SAVE_FEES", {
            sauidiFees: this.sauidiFees,
            VATFees: this.VATFees,
        });
    },
    mounted() {
        this.$store.dispatch("GET_CONTENT_LIST");
        if (this.$store.getters.contents.length) {
            this.contentItems = this.$store.getters.contents;
        }
        if (this.getViewsForForm2 == "env" && !this.contentItems.length) {
            this.contentItems.push({
                id: Math.random().toString(16).slice(2),
                title: null,
                unit_price: 0,
                quantity: 1,
                hs_code_id: null,
                weight: this.totalWeight,
                unit_system: "SI",
                currency: "SAR",
            });
        } else if (this.getViewsForForm2 == "env" && this.contentItems.length) {
            this.contentItems = [];
            this.contentItems.push({
                id: Math.random().toString(16).slice(2),
                title: this.$store.getters.contents[0].title,
                unit_price: 0,
                quantity: 1,
                hs_code_id: null,
                weight: this.totalWeight,
                unit_system: "SI",
                currency: "SAR",
            });
        }
        if (this.domestic_rate) {
            this.shipmentReson = "--";
        }

        if (this.contentItems.length) {
            this.current_unit_System = this.contentItems[0].unit_system;
            this.current_currency = this.contentItems[0].currency;
        }

        if (!this.contentItems.length) this.addNewItem();

        setTimeout(() => {
            this.isOpen = false;
        }, 3000);
    },
};
</script>

<style lang="scss" scoped>
.right-arrow {
    transform: rotate(90deg);
    transition: 0.3s;
    margin: 0 10px;

    &.active {
        transform: rotate(0deg);
    }
}

.note {
    margin: 20px 10px;
    padding-bottom: 20px;

    .note-body {
        h4 {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
        }

        div {
            p {
                font-size: 16px;
                color: #333;
            }
        }
    }
}

.info {
    background: #f7f7f7;
    padding: 25px;
    border-radius: 10px;

    .info-title {
        margin-bottom: 40px;

        h2 {
            font-size: 28px;
            color: #333;
            font-weight: bold;
        }
    }

    .info-title-bottom {
        margin-top: 40px;

        h2 {
            font-size: 28px;
            color: #333;
            font-weight: bold;
        }
    }

    hr {
        border-top: 4px solid #fff;
        width: 85%;
    }

    .top-lists {
        li {
            font-size: 18px;
            font-weight: bold;
            color: #000;
        }
    }

    .bottom-lists {
        padding: 0 40px;
        background: none;

        h4 {
            font-size: 28px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
        }

        li {
            font-size: 20px;
        }
    }
}

.options {
    padding: 0;
    margin-bottom: 30px;

    div {
        display: flex;
        margin: 15px 0;

        p {
            &.text {
                background: none;
                margin: 0;
            }

            background: #ddd;
            font-size: 16px;
            margin: 0 10px;
            padding: 2px 15px;
            border-radius: 5px;
            cursor: pointer;

            &.active {
                background: #ff7977;
                color: #000;
            }
        }
    }
}

.msg {
    display: flex;
    align-items: flex-start;
    padding: 10px;
    border-radius: 15px;
    background: #77a1ff40;
    position: relative;
    font-size: 14px;

    .mdi {
        border-radius: 50%;
        margin: 0 5px;
        padding: 0 5px;
        transition: 0.3s;

        &:hover {
            background: #ddd;
            cursor: pointer;
        }
    }
}

.missing-data {
    border: 1px solid #ff7977;
    border-radius: 6px;
    padding: 10px !important;

    &::placeholder {
        color: #ff7977;
    }
}

.danger {
    color: #ff7977;
}

.tooltip-ex {
    &::after {
        content: "!";
        position: absolute;
        display: inline-block;
        border: 1px solid #4f4f4f;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        font-size: 12px;
        top: 3px;
        margin: 3px;
        text-align: center;
    }
}

.rounded-7 {
    border-radius: 7px;
}

.py-0 {
    padding-top: 0;
    padding-bottom: 0;
}

.px-15 {
    padding: 0 15px;
}

.blue-label {
    background: #4952ff85;
    margin: 0 5px;
    padding: 8px 20px;
    border-radius: 50px;
}

.position-relative {
    position: relative;
    padding: 0;
}

.search-results {
    background-color: white;
    width: 250px;
    position: absolute;
    left: -15px;
    top: calc(100% + 1px);
    z-index: 2;
    box-shadow: 0 15px 15px 0 rgba(217, 217, 217, 0.3);
    border-radius: 0 0 25px 25px;

    ul {
        padding: 0 25px;
    }

    .results {
        cursor: pointer;
        padding: 8px 5px;

        .option {
            position: relative;

            span {
                margin-left: 60px;
            }
        }
    }

    .results:not(:first-child) {
        border-top: 1px solid #e6e6e6;
    }
}

.pieces {
    p {
        white-space: nowrap !important;
        font-size: 16px;
    }
}

.error {
    color: tomato;
}

.items {
    position: relative;
    display: flex;
    align-items: stretch;
    margin: 10px 0 40px;

    .itemParent {
        position: relative;
        width: 40%;
        overflow: inherit;
        // height: 100%;
        background: #f7f7f7;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .item {
            width: 90%;
        }

        .addToList {
            // position: absolute;
            // top: -14px;
            // right: 0;

            button {
                background: none !important;
                color: #000;
                transition: 0.3s;

                &:hover {
                    background: #fff !important;
                    border: 1px solid #000 !important;
                }
            }
        }
    }

    .lastParent {
        position: relative;

        .delete {
            position: absolute;
            top: 0;
            right: 0;
            border-radius: 4px;
            padding: 13px;
            background: none !important;

            &::after {
                background: #686868 !important;

                .modal-close::after {
                    height: 65%;
                }
            }

            &::before {
                background: #686868 !important;

                .modal-close::after {
                    height: 65%;
                }
            }
        }
    }

    .item {
        padding: 10px 8px;
        // text-align: center;
        position: relative;

        .title {
            position: relative;
            color: #686868;
            font-size: 0.95rem;
            font-weight: 500;
            border-bottom: 1px solid #333;
            margin: 0;
            padding: 10px 0;
            text-align: center;
        }

        .value {
            position: relative;

            span {
                position: absolute;
                top: 8px;
                right: 4px;
                color: #686868;
                font-size: 14px;
            }

            input {
                margin: 5px 0;
                background: none;
                font-size: 1em;
                text-align: center;
                width: 100%;
                padding: 10px 0;
                outline: none;
                display: flex;

                &:focus {
                    outline: none;
                }
            }

            /* Chrome, Safari, Edge, Opera */
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            /* Firefox */
            input[type="number"] {
                -moz-appearance: textfield;
            }
        }
    }
}

.form-container {
    padding: 1.5rem 1.5rem 3rem 1.5rem;
    box-sizing: inherit;
    transition: 0.4s ease-out;
    opacity: 1;

    .instructions {
        display: flex;
        align-items: center;

        p {
            text-align: left;
            font-size: 2rem;
            font-weight: bold;
            padding: 20px;
        }
    }

    #form-title-top {
        margin-bottom: 10px;
        display: inline-block;
        font-size: 25px;
    }

    #weight-dimension-instructions {
        background-color: #f7f7f7;
        color: black;
        border-radius: 25px;
        height: 100%;
        width: 100%;

        // &.note {
        //     width: 45%;
        // }

        p.title {
            text-align: center;
            font-size: 2rem;
            letter-spacing: 2px;
            font-weight: bold;
            padding-top: 14px;
            color: black;
        }

        a {
            color: #555;
            font-weight: bold;
            text-decoration: underline;

            &:hover {
                color: black;
            }
        }

        .instruction-body {
            padding: 15px 25px;
            text-align: justify;
            border-radius: 8px;
        }

        .button {
            background: none;
            color: black;
            height: 27px;
            font-size: 14px;

            &.c-tog {
                border-color: #333 !important;
            }
        }
    }

    .edit-item {
        cursor: pointer;
    }
}

.table thead td,
.table thead th {
    border-width: 0 0 2px;
    color: #fcfdff !important;
}

.table td,
.table th {
    border: 5px solid #fcfdff !important;
    border-width: 0 0 5px !important;
}

.backgrounded {
    background-color: #f7f7f7f7 !important;
}

.hide-form-container {
    opacity: 0;
}

.envTitle {
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 96%;
    height: 37px;
    padding: 0 10px;
}

.hidden {
    position: relative;
    overflow: hidden;
    width: 100%;
    min-height: 70px;
    margin-top: 15px;

    .hidden-item {
        position: absolute;
        transition: 0.4s linear;
        top: -200%;
        left: 0;
    }

    .show-item {
        top: 0 !important;
    }

    .control {
        text-align: left;
        border-bottom: 2px solid #9b9b9b;
        padding: 0 10px 0 0;
        width: 150px;
        position: relative;

        &::before {
            position: absolute;
            transition: 0.4s linear;
            content: "";
            display: inline-block;
            width: 100%;
            height: 2px;
            transform-origin: left;
            transform: scaleX(0);
            top: 100%;
            left: 0;
            background-color: #ffcb04;
            z-index: 10;
        }

        &::after {
            position: absolute;
            transition: 0.4s linear;
            content: "";
            display: inline-block;
            width: 100%;
            height: 2px;
            transform-origin: left;
            transform: scaleX(0);
            top: 100%;
            left: 0;
            background-color: #eb6174;
            z-index: 20;
        }

        &.dimensions {
            width: 110px !important;
            position: relative;
        }

        input {
            display: inline-block;
            height: 2rem;
            font-size: 1rem;
            padding: 5px;
            width: 100%;
        }
    }

    .control.active {
        &::before {
            transform: scaleX(1) !important;
        }
    }

    .control.error {
        &::after {
            transform: scaleX(1) !important;
        }
    }
}

.buttons {
    margin-top: 25px;
    align-items: flex-start !important;

    button {
        width: 100px;
    }

    #add {
        opacity: 0;
        transition: 0.4s linear;
    }

    .show-btn {
        opacity: 1 !important;
    }
}

.secondary-title {
    font-weight: 100;
}

@media screen and (max-width: 750px) {
    #form-title-top {
        font-size: 18px !important;
    }

    .secondary-title {
        font-size: 14px !important;
    }

    .text {
        font-size: 14px !important;
    }

    .items {
        flex-wrap: wrap;
        margin: 5px 0 20px !important;

        .addToList {
            button {
                transform: rotate(0deg) !important;
                margin: 10px;
            }
        }

        .itemParent {
            &:first-of-type {
                width: 100% !important;
                justify-content: space-between !important;

                .delete {
                    display: block !important;
                    margin: 0 10px !important;
                }
            }

            width: 50%;

            .title,
            .value {
                font-size: 14px !important;
            }
        }

        .lastParent {
            width: 100% !important;
            margin: 0 !important;

            .delete {
                display: none !important;
                margin: 0 10px !important;
            }
        }
    }

    .form-container {
        padding: 10px !important;
    }

    .info-title {
        margin-bottom: 10px !important;
        font-size: 18px !important;

        h2 {
            font-size: 18px !important;
        }
    }

    .info {
        padding: 10px;

        .collapse-trigger {
            li {
                font-size: 14px !important;
            }
        }
    }

    .notification {
        padding: 10px !important;

        li {
            font-size: 14px !important;
        }

        .content {
            .blue-label {
                font-size: 16px !important;
                padding: 5px 10px !important;
            }

            span {
                font-size: 16px !important;
            }

            .pieces {
                div {
                    margin: 10px !important;
                    width: 40% !important;

                    img {
                        width: 35px !important;
                    }

                    p {
                        font-size: 12px !important;
                    }
                }
            }
        }
    }

    .note {
        margin: 20px;

        h4 {
            font-size: 22px !important;

            img {
                width: 25px !important;
                height: 25px !important;
            }
        }

        p {
            font-size: 14px !important;
        }
    }

    .logo-sa {
        width: 125px !important;
    }
}
</style>
